// extracted by mini-css-extract-plugin
export default {"spinner":"exclusion-window-table_spinner__sQV7w","disabledMode":"exclusion-window-table_disabledMode__OfAIP"};